/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import { Button, Col, Form, Modal, Row, Select, Space, Table, Tabs } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { NavBar } from "../../../compnents/nav/NavBar"
import { RootDispatch } from "../../../app/store"
import axios from "axios"
import { useLocation } from "react-router-dom"
import styles from "../filing.module.css"
import { PreviewImgOrPdf } from "../Preview"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import { AXIOS_IP, exportPdf } from "../fileUploadService"
import moment from "moment"
import { DateTimeFormatSimplePrintCharge } from "../../../models/datetime"

export const ReplaceMakeDetail = () => {
  const { TabPane } = Tabs

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [baseUrl, setBaseUrl] = useState("")

  const [detail, setDetail] = useState<any>({})

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [token, setToken] = useState("")

  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const getData = () => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url:
            location.state?.state == 1
              ? `${AXIOS_IP}/filingDecoction/detail`
              : `${AXIOS_IP}/filingReviewDecoction/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: location.state?.id },
        }).then((res) => {
          const data = res.data.data
          const filterData = {
            ...data,
            clientDecoctionUrl: data?.clientDecoctionUrl || [],
            conditionReportUrl: data?.conditionReportUrl || [],
          }
          setDetail(filterData)
        })
      })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Col>
        <NavBar
          where={["备案管理", "代煎代配详情"]}
          backtrace={{
            name: "备案管理",
            path: "/filingManagement",
            state: { fillingType: location.state?.type },
          }}
          buttons={
            location.state?.state == 1 ? (
              [
                <Button
                  key="0"
                  type="primary"
                  loading={exportPdfLoading}
                  onClick={() =>
                    exportPdf({
                      data: { id: location.state?.id },
                      token,
                      path: "/filingDecoction/generatePdf",
                      fileName: "代煎代配备案详情.pdf",
                      callback: setExportPdfLoading,
                    })
                  }
                >
                  导出
                </Button>,
              ]
            ) : (
              <></>
            )
          }
        />
      </Col>
      <div
        style={{
          height: "calc(100% - 20px)",
          overflow: "auto",
          margin: "10px 0px",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Form
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          //   colon={false}
        >
          <Row
            style={{
              fontWeight: "bold",
              fontSize: "17px",
              paddingLeft: "15px",
              paddingBottom: "30px",
            }}
          >
            代煎代配详情
          </Row>
          <Row
            style={{
              fontWeight: "bold",
              fontSize: "17px",
              paddingLeft: "15px",
              paddingBottom: "30px",
            }}
          >
            基本信息
          </Row>
          <Form.Item label="是否委托第三方代煎代配" name="isClient" rules={[{ required: true }]}>
            {detail?.isClient == 1 ? "是" : "否"}
          </Form.Item>
          {detail?.isClient == 1 ? <>
            <Form.Item label="委托方机构名称" name="clientOrgName" rules={[{ required: true }]}>{detail?.clientOrgName}</Form.Item>
            <Form.Item label="委托方联系人姓名" name="clientName" rules={[{ required: true }]}>{detail?.clientName}</Form.Item>
            <Form.Item label="委托方联系方式" name="clientPhone" rules={[{ required: true }]}>{detail?.clientPhone}</Form.Item>
            <Form.Item label="委托代煎协议" name="clientDecoctionUrl" rules={[{ required: true }]}> 
              {detail?.clientDecoctionUrl?.map((v: any) => {
                return (
                  <span key={v.filePath}>
                    {v.fileName}{" "}
                    <a
                      style={{ color: "#0076FF", padding: "0 20px" }}
                      onClick={() => setPreviewFile(v)}
                    >
                      查看
                    </a>
                  </span>
                )
              })}
            </Form.Item>
          </> : ''}
          {detail?.conditionReport?.length > 0 ? <>
            <Row
              style={{
                fontWeight: "bold",
                fontSize: "17px",
                paddingLeft: "15px",
                paddingBottom: "10px",    
              }}
            >
              年度报告
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <Col offset={1} span={22}>
                <Table
                  dataSource={detail?.conditionReport || []}
                  columns={[
                    {
                      title: "序号",
                      key: "no",
                      align: "center",
                      width: "4rem",
                      render: (_1, _2, i) => `${i + 1}`,
                    },
                    {
                      title: "提交时间",
                      width: "10rem",
                      align: "center",
                      ellipsis: true,
                      dataIndex: "createTime",
                      render: (_, t) => {
                        return t.createTime
                          ? moment(t.createTime).format(
                              DateTimeFormatSimplePrintCharge
                            )
                          : "-"
                      },
                    },
                    {
                      title: "状态",
                      width: "8rem",
                      align: "center",
                      ellipsis: true,
                      dataIndex: "reviewStatusName",
                    },
                    {
                      title: "操作",
                      align: "center",
                      width: "8rem",
                      ellipsis: true,
                      render: function Element(_, m) {
                        return (
                          <Space>
                            <Button
                              type="link"
                              onClick={() =>
                                setPreviewFile(
                                  m.previousYearAssessmentReportFileUrl?.[0]
                                )
                              }
                            >
                              查看报告
                            </Button>
                          </Space>
                        )
                      },
                    },
                  ]}
                  rowKey={(t: any) => t.id}
                  pagination={false}
                />
              </Col>
            </Row>
          </> : ''}
        </Form>
      </div>

      <PreviewImgOrPdf
        token={token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
